export const environment = {
  production: true,
  apiBaseUrl: 'https://soundscape-synagoge.de/api/',
  clientBaseUrl: 'https://soundscape-synagoge.de',
  serviceBaseUrl: 'https://soundscape-synagoge.de/api/',
  storageUrl: 'https://soundscape-synagoge.de/storage/',
  imageUrl: 'https://soundscape-synagoge.de/img/',
};
